"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bundleActionSchema = exports.bundleCountsSchema = exports.bundleFilesSchema = exports.bundleFileSchema = exports.BUNDLE_FILE_CHANGES = void 0;
// Wire shapes of a bundle's detail, differences and actions (CR-004, J-185; CR-004-SPEC.md section 6;
// shadow plan section 7 "What changes"), served under `/api/v1/analysis-bundles/:bundleId`. The files are
// compared with the year's loaded bundle by name and sha256; the counts are the manifest's per ACO and
// measure beside the loaded bundle's. No shape carries a patient value: file names, hashes, codes and
// counts, and an admin without PHI access sees `file <id> · <sha256 first 12>` in place of a file name.
const zod_1 = require("zod");
exports.BUNDLE_FILE_CHANGES = ["added", "removed", "same", "same_name_new_content"];
/** One `core.bundle_file` row, of this bundle or (for `removed`) of the loaded one. */
exports.bundleFileSchema = zod_1.z
    .object({
    fileId: zod_1.z.string(),
    /** The file name, or `file <id> · <sha256 first 12>` for an admin without PHI access. */
    fileName: zod_1.z.string(),
    sha256: zod_1.z.string(),
    sizeBytes: zod_1.z.number().int(),
    layout: zod_1.z.string().nullable(),
    acoCode: zod_1.z.string().nullable(),
    disposition: zod_1.z.string(),
    dispositionReason: zod_1.z.string().nullable(),
    recordsRead: zod_1.z.number().int(),
    recordsLoaded: zod_1.z.number().int(),
    recordsSetAside: zod_1.z.number().int(),
    /** Reason code → records set aside for it. */
    setAsideReasons: zod_1.z.record(zod_1.z.string(), zod_1.z.number().int()),
    change: zod_1.z.enum(exports.BUNDLE_FILE_CHANGES),
})
    .meta({ id: "AcoBundleFile" });
exports.bundleFilesSchema = zod_1.z
    .object({
    bundleId: zod_1.z.uuid(),
    /** The year's loaded bundle the files are compared with; null when none is loaded. */
    comparedWith: zod_1.z.uuid().nullable(),
    /** This bundle's files by name, then the loaded bundle's files this one does not have. */
    files: zod_1.z.array(exports.bundleFileSchema),
})
    .meta({ id: "AcoBundleFiles" });
/** One ACO × measure's counts from a manifest's `hashes` entry. */
const measureCountsSchema = zod_1.z.object({
    rows: zod_1.z.number().int(),
    met: zod_1.z.number().int(),
    notMet: zod_1.z.number().int(),
    excluded: zod_1.z.number().int(),
    exception: zod_1.z.number().int(),
    completenessPct: zod_1.z.number(),
});
exports.bundleCountsSchema = zod_1.z
    .object({
    bundleId: zod_1.z.uuid(),
    comparedWith: zod_1.z.uuid().nullable(),
    /** One row per ACO and measure either manifest names, by ACO then measure. */
    rows: zod_1.z.array(zod_1.z.object({
        acoCode: zod_1.z.string(),
        measureNumber: zod_1.z.string(),
        /** Null when this bundle (or the loaded one) has no row for the pair. */
        bundle: measureCountsSchema.nullable(),
        loaded: measureCountsSchema.nullable(),
    })),
})
    .meta({ id: "AcoBundleCounts" });
/** The answer to a load or re-validation request (202): the bundle loop does the work. */
exports.bundleActionSchema = zod_1.z
    .object({
    bundleId: zod_1.z.uuid(),
    action: zod_1.z.enum(["load", "rollback", "validate"]),
})
    .meta({ id: "AcoBundleAction" });
//# sourceMappingURL=bundle-differences.js.map